import { Guid } from "guid-typescript";

import { ValidationIssueSeverity } from "infrastructure/validation";
import { extractApiErrorMessageContent } from "ui/shared/models/common";

import { IMessagesUploadResponseItem } from "./MessagesUpload.api";
import { IMessagesUploadValidationIssue } from "./MessagesUpload.state";

export const getValidationIssues = (response: IMessagesUploadResponseItem[]): IMessagesUploadValidationIssue[] => {
  return (
    response &&
    response.map<IMessagesUploadValidationIssue>(e => {
      return {
        uniqueId: e.uniqueId ? e.uniqueId : Guid.raw(),
        messageId: e.messageId,
        tokens: e.tokens,
        text: e.text,
        validationIssue: {
          severity: ValidationIssueSeverity.Error,
          message: extractApiErrorMessageContent(e.error)
        }
      };
    })
  );
};
